import { Component, OnInit } from '@angular/core';
import { ISetOrResetPasswordRequest } from '@modeso/aumico-lib-users-fe';
import { PasswordsBasePage } from '../passwords-base.page';

@Component({
    selector: 'aumico-reset-password',
    templateUrl: './reset-password.page.html',
    styleUrls: ['./reset-password.page.scss'],
})
export class ResetPasswordPage extends PasswordsBasePage implements OnInit {
    onPasswordReset(setPasswordData: ISetOrResetPasswordRequest): void {
        this.authProvider.dispatchResetPassword(setPasswordData);
    }
}
